{
  "addAddress": "Aggiungi indirizzo",
  "addContactData": "Aggiungere i dati di contatto",
  "additionalId": "Numero di articolo",
  "additionalStockInfos": "Ulteriori informazioni sulle azioni",
  "additionalTax": "più{0} di IVA",
  "addProducts": "Aggiungi prodotti",
  "addProductToCollection": "Aggiungi il prodotto a una collezione",
  "addProductToComparison": "Aggiungi prodotto al confronto dei prodotti",
  "addProductToQuote": "Aggiungi il prodotto a una richiesta",
  "address": {
    "addition": "Dato di indirizzo addizionale",
    "city": "Città",
    "clientNumber": "Numero cliente",
    "companyName": "Nome e forma giuridica",
    "country": "Paese",
    "defaultBillingAddress": "Indirizzo di fatturazione predefinito",
    "defaultDeliveryAddress": "Indirizzo di spedizione predefinito",
    "details": "Dettagli",
    "email": "Email",
    "phone": "Telefono",
    "postBox": "Casella postale",
    "primaryAddress": "Indirizzo primario",
    "street": "Via",
    "url": "URL",
    "website": "Sito web",
    "zipCode": "Codice postale",
    "zipCodeLong": "Codice postale"
  },
  "addresses": "Indirizzi",
  "addToCart": "Aggiungi al carrello",
  "archiveAll": "Archivia tutto",
  "availability": "Disponibilità",
  "b2bCommerPowered": "Powered by ITscope B2B Commerce",
  "backToPlatform": "Torna a ITscope",
  "billingAddress": "Indirizzo di fatturazione",
  "cancel": "Annulla",
  "cart": {
    "optimizationFailed": "L'ottimizzazione del carrello non è riuscita",
    "optimizationUnavailable": "Non è stato possibile eseguire l'ottimizzazione del carrello perché ci sono troppi articoli nel carrello",
    "removeAll": "Svuotare carrello",
    "removeAllError": "Non è stato possibile svuotare il carrello",
    "removeAllSuccess": "Il carrello è stato svuotato con successo"
  },
  "cartOutdated": {
    "description": "Non è stato possibile inviare l'ordine perché il carrello non è più aggiornato. Ricaricare il carrello ed effettuare nuovamente l'ordine.",
    "title": "Il carrello non è più aggiornato"
  },
  "cartPositionComment": "Note per l'articolo",
  "categories": "Categorie",
  "changed": "Modificato",
  "changePassword": "Modifica della password",
  "charger": {
    "charger": "Caricatore incluso",
    "chargerIncludedTooltip": "Il caricabatterie è incluso con questo prodotto.",
    "chargerNotIncludedHint": "I caricabatterie con le seguenti compatibilità di ricarica possono essere utilizzati con questo prodotto.",
    "chargerNotIncludedTooltip": "Il caricabatterie non è incluso con questo prodotto.",
    "noCharger": "Caricatore non incluso"
  },
  "checkEmail": "Controllare la posta elettronica",
  "checkoutExpiredDialog": {
    "buttonCaption": "Torna alla cassa",
    "description": "Il vostro ordine è in attesa",
    "title": "Sei ancora lì?"
  },
  "chooseAddress": "Scegliere l'indirizzo",
  "clientNumber": "Numero cliente",
  "closeErrorOrders": "Chiudere la colonna con gli ordini errati",
  "closeFilter": "Chiudi il filtro",
  "closeMessage": "Chiudere il messaggio",
  "closeQuoteActivity": "Chiudere le attività",
  "collapseAccessoryCategory": "Crollo della categoria di accessori “{0}”",
  "collapseDescription": "Descrizione di collasso “{0}”",
  "collection": {
    "addAttachment": "Aggiungi allegato",
    "addCollection": "Nuova collezione",
    "addedToCartFailure": "Non è stato possibile aggiungere la collezione al carrello",
    "addedToCartPartialSuccess": "Non è stato possibile aggiungere alcuni articoli al carrello",
    "addedToCartSuccess": "Aggiunta al carrello della collezione",
    "addProductToExistingCollection": "Aggiungere un prodotto alla collezione esistente:",
    "addProductToNewCollection": "o creare una nuova collezione:",
    "addToCart": "Aggiungi al carrello",
    "assignee": "Dipendente responsabile",
    "collections": "Collezioni",
    "collectProduct": "Raccogliere il prodotto",
    "data": "Date",
    "deleteAction": "Cancella",
    "deleteDialog": "Sei sicuro di voler rimuovere questa collezione?",
    "deletedMessage": "La collezione è stata rimossa",
    "duplicate": "Duplicato",
    "editTitle": "Cambia il titolo della raccolta",
    "emailSent": "La raccolta è stata inviata con successo via e-mail.",
    "emptyCollection": "Nessun prodotto in questa collezione",
    "lastModified": "Ultima modifica",
    "noCollectionAvailable": "Nessuna raccolta disponibile",
    "productAlreadyInCollection": "Prodotto già presente nella collezione",
    "sendEmail": "Condividi per e-mail",
    "shareCollection": "Condividi la raccolta \"{0}\" via e-mail",
    "subject": "Oggetto",
    "success": {
      "itemRemoved": "Prodotto rimosso con successo"
    }
  },
  "common": {
    "archive": "Archivio",
    "archived": "Archiviato",
    "comment": "Commento",
    "commentPlaceholder": "Aggiungi un commento qui...",
    "comments": "Commenti",
    "dearchive": "Dearchive",
    "error": {
      "changeQuantity": "Non è stato possibile modificare la quantità",
      "removeItem": "Non è stato possibile eliminare l'elemento",
      "updateAssignee": "Non è stato possibile cambiare il dipendente responsabile",
      "updateComment": "Non è stato possibile aggiornare il commento",
      "updateName": "Non è stato possibile aggiornare il titolo della raccolta"
    },
    "sellerComment": "Commento per il venditore"
  },
  "company": {
    "deleteEmployee": "Rimuovere il dipendente",
    "employee": "Dipendente",
    "employeeDeleted": "Il dipendente è stato rimosso",
    "employees": "I dipendenti"
  },
  "companyData": "Dati aziendali",
  "companyRegistration": "Non esiste ancora un'azienda per l'indirizzo e-mail fornito. Compilare il modulo sottostante per richiedere l'accesso.",
  "condition": {
    "B_STOCK": "B Stock",
    "BUILD_TO_ORDER": "Costruire su ordinazione",
    "BULK": "Bulk",
    "DEMONSTRATION_MODEL": "Modello dimostrativo",
    "FACTORY_REFURBISHED": "Rinnovato in fabbrica",
    "NEW": "Nuovo",
    "NEWPULL": "Pezzo di ricambio di un nuovo dispositivo",
    "NOT_FOR_RESALE": "Non per la rivendita",
    "REFURBISHED": "Rinnovato",
    "RMA_WARE": "RMA",
    "USED": "Usato",
    "USEDPULL": "Pezzo di ricambio da dispositivo usato"
  },
  "conditionTooltip": {
    "conditionLabel": "Condizione",
    "monthsWarranty": "mesi di garanzia"
  },
  "contactData": {
    "contactData": "dettagli di contatto",
    "email": "E-mail",
    "firstName": "Nome",
    "lastName": "Cognome"
  },
  "contactTitles": {
    "diverse": "Diverso",
    "female": "Sig.ra.",
    "male": "Sig.",
    "unspecified": "non specificato"
  },
  "continue": "Continua",
  "copy": "Copia",
  "coreData": "Core Data",
  "costs": "Costi",
  "create": "Creare",
  "created": "Creato",
  "createdDate": "Data di creazione",
  "cto": {
    "appleCtoFinder": "Trova il CTO di Apple",
    "configure": "Configure {0}",
    "customiseConfiguration": "Personalizzare la configurazione",
    "foundProduct": "Prodotto trovato",
    "noProductFound": "Non è stato possibile trovare alcun prodotto per questa configurazione",
    "selectBaseModel": "Selezionare il modello base",
    "selectedConfiguration": "Configurazione selezionata",
    "selectProductClass": "Selezionare la classe di prodotto Apple"
  },
  "customerOrderId": "Numero d'ordine del cliente",
  "datasheet": "Scheda tecnica",
  "datasheetError": "Impossibile caricare la scheda tecnica",
  "datasheetManufacturer": "Scheda tecnica del produttore",
  "datasheetNotFound": "Nessun foglio di dati disponibile per questo prodotto",
  "datasheetPdf": "Scheda tecnica (PDF)",
  "decline": "Declino",
  "declineReason": "Motivo del declino",
  "delete": "Cancella",
  "deleteAddress": "Cancella l'indirizzo",
  "deleteAddressDialog": "È sicuro di voler cancellare questo indirizzo?",
  "deleteContactData": "Cancellare i dati di contatto",
  "deliveryTracking": {
    "deliveryTracking": "Informazioni sulla spedizione",
    "trackPackage": "Pacchetto pista"
  },
  "departments": {
    "Accounting": "Contabilità",
    "Extern": "Esterno",
    "IT": "IT",
    "Management": "Gestione",
    "Marketing": "Marketing",
    "Other": "Altro",
    "Purchasing": "Acquisto",
    "RegistrationPending": "In attesa di registrazione",
    "Sales": "Vendite",
    "ServiceSupport": "Servizio/Supporto"
  },
  "discount": "- {0} di sconto",
  "documentError": "Impossibile caricare il documento",
  "downloadAllOrderDocumentsAsPdf": "Scarica tutti i documenti dell'ordine in formato PDF",
  "downloadOrderDocumentAsPdf": "Scarica il documento d'ordine “{0}” in formato PDF",
  "ean": "EAN",
  "editAddress": "Modifica indirizzo",
  "editCollectionAssignee": "Cambiare dipendente responsabile",
  "editContactData": "Modifica dei dati di contatto",
  "ellipsis": "...",
  "emailAddress": "Indirizzo e-mail",
  "emailForRegistration": "Inserisci un indirizzo email con cui si desidera registrarsi.",
  "emailRequestPriceHint": "La seguente mail sarà inviata al proprietario del negozio (questa è solo un'anteprima del testo):",
  "emptyCart": "Non c'è nessun prodotto nel carrello",
  "epeat": "Certificato EPEAT",
  "epeatTooltip": {
    "description1": "Ecolabel internazionale per i prodotti IT.",
    "description2": "Valuta, tra l'altro, l'efficienza energetica, la riciclabilità e la scelta dei materiali.",
    "description3": "Livelli: Bronzo, Argento, Oro - più è alto, più è ecologico.",
    "title": "Etichetta EPEAT"
  },
  "eprel": {
    "energyEfficiency": "Etichetta energetica",
    "energyEfficiencyAndProductDatasheet": "Informazioni sull’etichetta energetica",
    "energyEfficiencyInformationSheet": "Scheda tecnica"
  },
  "error": {
    "addressCreated": "Non è stato possibile creare un indirizzo",
    "addressDeleted": "Non è stato possibile cancellare l'indirizzo",
    "addressesNotFound": "Non è stato possibile caricare gli indirizzi",
    "addressPropertyInvalid": "Il campo indirizzo {propertyName} non è valido.",
    "addressSaved": "Non è stato possibile salvare l'indirizzo",
    "alreadyInvited": "Il collega {0} è già invitato",
    "alreadyRegistered": "Il collega {0} è già registrato",
    "cartNotFound": "Il carrello non può essere caricato",
    "categoriesNotFound": "Le categorie non possono essere caricate",
    "changePassword": "Qualcosa è andato storto durante il tentativo di cambiare la password",
    "changeQuantity": "Non è stato possibile modificare la quantità nel carrello",
    "collectionNotFound": "Impossibile caricare la collezione",
    "documentsNotFound": "Impossibile caricare i documenti",
    "emailAlreadyRegistered": "L'e-mail è già registrata.",
    "emptyField": "Il campo {0} deve avere un valore valido",
    "essentialShopActivationRequested": "Si è verificato un errore durante l'invio della richiesta",
    "fileTooLarge": "La dimensione del file è troppo grande",
    "genericError": "Qualcosa è andato storto",
    "identifiersNotFound": "Non è stato possibile caricare gli identificatori",
    "invalidCharacters": "Sono ammessi solo lettere, numeri e i caratteri _ / . # +, oltre alle parentesi e alle parentesi quadre (minimo 3 caratteri)",
    "invalidEmail": "Indirizzo e-mail non valido",
    "invalidEmails": "I seguenti indirizzi di posta elettronica non sono validi: {0}",
    "invalidName": "Nome non valido",
    "invalidNegativeNumber": "Sono ammessi solo numeri positivi",
    "invalidNumber": "Numero non valido",
    "invalidUrl": "URL non valido",
    "invalidWhitespace": "Non sono consentiti spazi iniziali, finali o multipli consecutivi",
    "invitation": "Qualcosa è andato storto durante il tentativo di inviare l'invito",
    "keywordTooShort": "Inserire un termine di ricerca con almeno 2 caratteri",
    "mailBlacklisted": "Il dominio {0} non è stato inserito nella whitelist. Contattare l'amministratore del portale.",
    "noAdmin": "Per invitare i colleghi è necessario disporre dei diritti di amministratore",
    "noConsent": "Il consenso deve essere firmato",
    "oldPassword": "Password corrente non valida",
    "ordersNotFound": "Impossibile caricare gli ordini",
    "pageNotFound": "Pagina non trovata",
    "passwordNotAllowedChar": "La password contiene uno o più caratteri vietati.",
    "passwordRepeat": "I valori nei campi password non corrispondono",
    "passwordRequirements": "La password non soddisfa i requisiti attuali.",
    "positiveDigit": "Il valore deve essere positivo",
    "productAdded": "Non è stato possibile aggiungere il prodotto al carrello",
    "productAlreadyInComparison": "Il prodotto è già a confronto",
    "productComparisonMaxNumber": "È possibile confrontare un massimo di 3 prodotti",
    "productDeleted": "Non è stato possibile rimuovere il prodotto dal carrello",
    "productNotAvailableBySupplier": "Questo fornitore non offre il prodotto.",
    "productNotFound": "Impossibile caricare il prodotto",
    "productRequest": "Qualcosa è andato storto durante il tentativo di inviare la richiesta",
    "productTypeIncorrectForComparison": "Solo i prodotti della stessa categoria possono essere confrontati tra loro",
    "quoteForbidden": "L'offerta non è ancora attiva",
    "quoteNotFound": "L'offerta non può essere caricata",
    "quotesNotFound": "Impossibile caricare le offerte",
    "refresh": "Altri utenti hanno apportato modifiche. Aggiornare la pagina.",
    "registration": "Qualcosa è andato storto durante il tentativo di inviare la registrazione",
    "registrationTokenError": "Il link per la registrazione di un nuovo utente sembra essere difettoso. Si prega di richiederne uno nuovo.",
    "requiredField": "Campo obbligatorio",
    "resetPassword": "Qualcosa è andato storto durante il tentativo di reimpostare la password",
    "resetTokenError": "Il link per reimpostare la passwort non è più valido. Si prega di richiederne una nuova.",
    "serverError": "Errore del server",
    "shortPassword": "Deve essere lungo almeno 8 caratteri",
    "startPage": "La pagina iniziale non può essere caricata",
    "timeout": "La richiesta è scaduta",
    "tooManyRequests": "Troppe richieste. Riprova più tardi.",
    "unknownError": "Si è verificato un errore sconosciuto durante la richiesta ({0}).",
    "unknownLoginError": "Si è verificato un errore sconosciuto durante l'accesso.",
    "unsupportedMediaType": "Il tipo di file non è supportato",
    "updateComment": "Non è stato possibile aggiornare il commento a testo libero",
    "userDeactivated": "L'utente specificato è disattivato, il login non è attualmente possibile.",
    "validDigit": "Il valore deve essere un numero intero valido",
    "wrongCredentials": "L'indirizzo e-mail o la password non sono corretti."
  },
  "errorId": "ID errore",
  "errorPageHeadline": "Qualcosa è andato storto.",
  "errorPageOops": "Ooops",
  "errorPageQuoteNotAvailableSorry": "Riprova più tardi.",
  "errorPageStart": "Vai alla pagina iniziale",
  "essentialShopDeactivated": {
    "descriptionEnd": "Contatta il tuo partner per ottenere l'accesso.",
    "descriptionPoint1": "visualizzare la cronologia delle tue offerte",
    "descriptionPoint2": "inviare richieste di offerte direttamente al tuo partner",
    "descriptionPoint3": "accedere a un assortimento di 50.000 prodotti IT con filtro e funzione di ricerca",
    "descriptionPoint4": "ordinare in modo semplice e diretto",
    "descriptionStart": "Nell'Essential Shop hai la possibilità di:",
    "descriptionTitle": "L'Essential Shop del tuo partner è attualmente disattivato.",
    "pageTitle": "Essential Shop disattivato",
    "requestActivation": "Richiedi l'attivazione",
    "requestActivationHint": "Inserisci il tuo indirizzo e-mail in modo che il tuo partner possa contattarti."
  },
  "excludingVatHint": "Tutti i prezzi sono esclusi di{0} di IVA",
  "excludingVatShort": "IVA{0} escl.",
  "expandAccessoryCategory": "Espandere la categoria di accessori “{0}”.",
  "expandDescription": "Espandere la descrizione “{0}”",
  "featureAd": {
    "comparison": {
      "description": "È possibile aggiungere i prodotti per il confronto tramite la pagina del prodotto.",
      "shortDescription": "Ora è possibile confrontare i prodotti.",
      "title": "Confronto tra prodotti"
    },
    "descriptionEnd": "Vi invieremo il preventivo, il quale potrà essere ordinato direttamente qui sul vostro portale.",
    "descriptionStart": "Potete richiedere un preventivo nel seguente modo:",
    "NEW": "NUOVO",
    "requestFunction": "Invio di richieste per un preventivo",
    "step1": "Fare clic su \"Creare una richiesta\"",
    "step2": "Aggiungi i prodotti",
    "step3": "Invia la richiesta",
    "tryItOut": "Provate!"
  },
  "filter": {
    "filter": "Filtro",
    "filters": "Filtri",
    "noFiltersSelected": "Nessun filtro selezionato",
    "productFilters": "Caratteristiche",
    "productType": "Tipo di prodotto",
    "resetFilter": "Azzeramento del filtro"
  },
  "finishRegistration": "Terminare la registrazione",
  "forgotPassword": "Hai dimenticato la password?",
  "grading": {
    "A": "Come nuovo",
    "B": "Molto buono",
    "C": "Buono",
    "D": "Accettabile"
  },
  "hideCategories": "Nascondi categorie",
  "hideCategory": "Piega la categoria",
  "hidePassword": "Nascondi la password",
  "impersonateMode": "Vista del cliente - Avete effettuato l'accesso come amministratore del negozio B2B in {0}",
  "impersonateModeEssentialShop": "Visualizzazione cliente – Registrato come gestore del negozio",
  "includingVat": "incl. {0} IVA",
  "includingVatHint": "Tutti i prezzi sono comprensivi di {0} di IVA",
  "includingVatShort": "incl. {0} IVA",
  "invitationHint": "Qui è possibile invitare altri colleghi al proprio portale. Inserire gli indirizzi e-mail a cui si desidera inviare l'invito e separarli con un punto e virgola o uno spazio.",
  "inviteColleagues": "Invitare i colleghi",
  "languages": {
    "de": "Tedesco",
    "en": "Inglese",
    "es": "Spagnolo",
    "fr": "Francese",
    "it": "Italiano",
    "nl": "Olandese",
    "pl": "Polacco"
  },
  "legalInfo": "Informazioni legali",
  "less": "meno",
  "localization": "Localizzazione",
  "login": "Accesso",
  "login_sso": "Accesso con Single Sign-On (SSO)",
  "loginQuotesPortal": "Accesso al portale delle offerte",
  "manufacturerId": "ID produttore",
  "max": "Max.",
  "maxLength": "Lunghezza massima dei caratteri di {0} raggiunta",
  "mobex360Info": "Se il credito di mobex360 è insufficiente, l'ordine verrà automaticamente fatturato!",
  "mobexPaymentMethod": {
    "CREDIT": "Con il credito mobex360",
    "INVOICE": "Per fattura"
  },
  "more": "di più",
  "moreInfoEpeatTooltip": "Ulteriori informazioni sul marchio EPEAT",
  "moreUppercase": "Di più",
  "myCompany": "La mia azienda",
  "myProfile": "Il mio profilo",
  "name": "Nome",
  "newPassword": "Nuova password",
  "newPasswordRepeat": "Confermare la nuova password",
  "no": "No",
  "noAppleProductsAvailable": "Nessun prodotto Apple disponibile",
  "noCategoriesFound": "Nessuna categoria disponibile",
  "noCollectionsFound": "Nessuna collezione disponibile",
  "noDataAvailable": "Non sono disponibili dati",
  "noEntries": "Nessuna voce disponibile",
  "noImageAvailable": "Nessuna immagine disponibile",
  "noItemsInQuote": "La presente offerta non contiene posizioni",
  "noOrderDocumentsFound": "Nessun documento disponibile",
  "noOrdersFound": "Nessun ordine disponibile",
  "noProductsFound": "Nessun prodotto trovato",
  "noSupplier": "Non assegnato",
  "nullPriceLabel": "-.--",
  "oldPassword": "Password attuale",
  "onlyWholePositiveNumbers": "Sono ammessi solo numeri interi positivi",
  "open": "Aperto",
  "openCart": "Apri il carrello",
  "openCategory": "Piega la categoria",
  "openFilter": "Apri il filtro",
  "openMenu": "Menu aperto",
  "openProductComparison": "Apri il confronto dei prodotti",
  "openProductPage": "Aprire la pagina del prodotto",
  "openTopiCheckout": "Aprire la cassa topi",
  "optimizationStrategyType": {
    "MANUAL": "Manualmente",
    "MINPRICE": "Miglior prezzo",
    "MINSUPPLIERS": "Fonti minime"
  },
  "order": {
    "addedToCartFailure": "Non è stato possibile aggiungere l'ordine al carrello",
    "addedToCartPartialSuccess": "Non è stato possibile aggiungere alcuni articoli al carrello",
    "addedToCartSuccess": "Ordine aggiunto al carrello",
    "customerOrderIdMissing": "È necessario indicare l'id dell'ordine del cliente.",
    "declineOrder": "Declinare l'ordine",
    "deleteDialog": "È sicuro di voler cancellare questo ordine?",
    "deleteLastItemDialog": "Attenzione: Quando si cancella l'ultimo elemento dell'ordine, viene cancellato anche l'ordine completo. Volete continuare?",
    "deleteOrder": "Cancella ordine",
    "deleteOrderItem": "Cancellare la posizione dell'ordine",
    "details": "Ordine",
    "documents": "Documenti",
    "editAddressHint": "Le modifiche all'indirizzo hanno effetto solo su questo ordine.",
    "exclTotalTax": "excl.{0} IVA {1}",
    "goToOrder": "Procedi con l'ordine",
    "inclTotalTax": "incl.{0} IVA {1}",
    "inEuTotalTax": "più{0} IVA {1}",
    "moreInfosLabel": "Ulteriori dettagli",
    "netDiscount": "Sconto aggiuntivo",
    "noApprover": "Sembra che non ci siano approvatori idonei per questo ordine. Si prega di contattare l'operatore del portale.",
    "noOrderRightHint": "Non avete il permesso di eseguire l'ordine.",
    "order": "Ordine",
    "orderAlreadyBeingProcessed": "L'ordine è già in elaborazione. Attendere qualche minuto.",
    "orderDate": "Data dell'ordine",
    "orderLimitApprovalHint": "Le seguenti persone saranno informate via e-mail della richiesta di approvazione dell'ordine. Non appena l'approvazione dell'ordine sarà confermata o rifiutata, sarete informati via e-mail.",
    "orderLimitHint": "L'ordine del valore di {0} ha superato il limite d'ordine attuale di {1}. Si prega di richiedere l'approvazione dell'ordine.",
    "orderNotFound": "L'ordine non può essere caricato",
    "orderNumber": "Numero d'ordine",
    "orderNumberDuplicate": "Il numero d'ordine {0} è già stato utilizzato per un ordine. Provare con un altro numero d'ordine.",
    "orderNumberGeneratedAfterOrder": "Viene generato dopo l'ordine",
    "orderNumberMissing": "È necessario indicare un numero d'ordine.",
    "orderNumbers": "Numeri d'ordine",
    "orderRequested": "Richiesta inviata",
    "orders": "Ordini",
    "orderSent": "L'ordine è stato trasmesso ed è in fase di elaborazione.",
    "orderTimeoutError": "Nessuna risposta all'ordine ricevuta. Ricaricare la pagina.",
    "partialShipmentAllowed": "Spedizione parziale consentita",
    "paymentMethodMissing": "È necessario indicare un metodo di fatturazione.",
    "quantitySurcharge": "Supplemento per ordine minimo",
    "requestOrder": "Richiesta",
    "selectAddressHint": "È possibile utilizzare solo gli indirizzi creati dall'utente.",
    "sendOrder": "Conferma l'ordine",
    "shippingAddress": "Indirizzo di spedizione",
    "shippingCosts": "Spedizione",
    "shippingCostsGross": "Costi di spedizione al lordo",
    "shippingCostsNet": "Costi di spedizione netti",
    "subTotal": "Subtotale",
    "toOrder": "Effettuare l'ordine",
    "toOrderFrom": "Ordine da {0}",
    "totalCostsGross": "Importo totale lordo",
    "totalCostsNet": "Importo totale netto"
  },
  "orderApproval": {
    "approvableOrders": "Ordini approvabili",
    "approvedInformation": "L'ordine è stato accettato da {0} su {1}..",
    "declinedInformation": "L'ordine è stato rifiutato da {0} il {1}.",
    "orderDeclined": "Ordine rifiutato con successo",
    "pendingInformation": "È stata richiesta una liberatoria da {1} per quest' ordine su {0} alle seguenti persone:",
    "pendingInformationApprover": "Per quest' ordine è stata inviata una liberatoria il {0}.",
    "pendingInformationRequester": "Il {0} è stato inviato un ordine di rilascio alla seguente persona:"
  },
  "orderBy": "Ordine effettuato con {0}",
  "ordered": "Ordinato",
  "orderLimits": {
    "activateOrderLimits": "Attivare i limiti degli ordini",
    "default": "Predefinito",
    "defaultApprovers": "Approvatore predefinito",
    "defaultApproversEmpty": "Non è stato selezionato un approvatore predefinito",
    "defaultApproversUsed": "Vengono utilizzati gli approvatori predefiniti",
    "defaultLimit": "Limite generale",
    "defaultLimitDescription": "Questo limite d'ordine è il valore predefinito per tutti i dipendenti e viene sovrascritto da limiti d'ordine specifici per i dipendenti.",
    "description": "Assegnando dei limiti, i dipendenti possono ordinare solo fino a un determinato valore. Gli ordini che superano questo valore devono essere richiesti a un collega con diritti di approvazione.",
    "editOrderLimitUser": "Modificare il limite d'ordine dell'utente “{0}”.",
    "editStandardApprovers": "Modifica degli approvatori predefiniti",
    "individual": "Individuale",
    "noEmployeeFound": "Nessun dipendente trovato",
    "noEmployeesFound": "Non ci sono dipendenti",
    "orderApproval": "Approvazione dell'ordine",
    "orderApprover": "Approvazione dell'ordine",
    "orderLimit": "Limite d'ordine",
    "orderRight": "Ordine giusto",
    "unlimited": "Illimitato"
  },
  "orderOutdated": {
    "description": "Non è stato possibile inviare l'ordine perché non è aggiornato. Si prega di ricaricare l'ordine ed eseguirlo nuovamente.",
    "title": "Ordine non più aggiornato"
  },
  "orderStatus": {
    "ADVISED": "Spedito",
    "ARRIVED": "Ordine ricevuto",
    "ARRIVED_WARNING": "Ricevuto con avviso",
    "BLOCKED": "Bloccato",
    "BLOCKED_BYLIMIT": "Bloccato",
    "CANCELED": "Annullato",
    "ERROR": "Errore",
    "IN_TOPI_CHECKOUT": "Nella cassa topi",
    "INVOICED": "Fatturato",
    "ORDERED_ELSEWHERE": "Ordinato altrove",
    "PARTIALLY_ADVISED": "Parzialmente spedito",
    "PARTIALLY_INVOICED": "Parzialmente fatturati",
    "PARTIALLY_PROCESSING": "Parzialmente confermato",
    "PAYMENT_AWAITING": "In attesa di pagamento",
    "PAYMENT_SUCCESSFUL": "Pagamento andato a buon fine",
    "PENDING_TOPI_APPROVAL": "In attesa di autorizzazione",
    "PORTAL_APPROVAL_DENIED": "Rifiutato",
    "PREPARING": "In attesa",
    "PROCESSING": "Ordine confermato",
    "REJECTED": "Rifiutato",
    "SENDING_ERROR": "Errore di trasmissione",
    "SENT": "Trasmesso",
    "TOPI_DECLINED": "Rifiutato da topi",
    "TOPI_EXPIRED": "Offerta topi scaduta",
    "TRANSMITTING": "Trasmissione"
  },
  "partsList": "Elenco delle parti",
  "password": "Password",
  "passwordRepeat": "Ripetere la password",
  "paymentMethod": "Metodo di pagamento",
  "PDF": "PDF",
  "per": "per",
  "personalData": "Dati personali",
  "pleaseSelect": "Selezionare...",
  "portal": "Portale",
  "portalPaused": "Portale in pausa",
  "portalPausedDescription": "Questo portale è attualmente in pausa, pertanto non è possibile effettuare il login. In caso di domande, si prega di contattare il proprietario del portale.",
  "positions": "Nessuna posizione | {n} posizione | {n} posizioni",
  "price": {
    "graduatedPrices": "Prezzi graduati",
    "manufacturerSuggestedRetailPrice": "MSRP",
    "packaging": "Unità di imballaggio",
    "packaging_contentUnit": "Unità di contenuto:",
    "packaging_contentUnit_label": "Unità dell'articolo all'interno di un'unità d'ordine (ad esempio, \"pezzo\" nell'unità d'ordine \"confezione\").",
    "packaging_intervalQuantity": "Intervallo di quantità:",
    "packaging_intervalQuantity_label": "Quantità che indica l'intervallo in cui l'articolo può essere ordinato (in unità d'ordine).",
    "packaging_minQuantity": "Quantità minima ordinabile:",
    "packaging_minQuantity_label": "La quantità minima di scorte che deve essere ordinata.",
    "packaging_numberContentUnitPerOrderUnit": " Quantità di imballaggio:",
    "packaging_numberContentUnitPerOrderUnit_label": "Il numero di subunità contenute nell'unità dell'articolo.",
    "packaging_orderUnit": "Unità d'ordine:",
    "packaging_orderUnit_label": "Unità in cui è possibile ordinare il prodotto; è possibile ordinare solo multipli dell'unità dell'articolo.",
    "packaging_priceQuantity": "Price quantity:",
    "packaging_priceQuantity_label": "Un multiplo dell'unità d'ordine, che indica la quantità a cui si riferiscono i prezzi.",
    "packaging_supplierPackingQuantity": "Quantità di imballaggio del fornitore:",
    "packaging_supplierPackingQuantity_label": " Quantità di imballaggio del fornitore (in unità d'ordine).",
    "price": "Prezzo",
    "priceBillingPeriod": "per {0}",
    "priceBillingPeriodShort": "p. {0}",
    "priceOnRequest": "O/R",
    "pricePurchase": "WSP",
    "priceSubscriptionPeriod": "{0} periodo contrattuale",
    "priceVatStar": "*",
    "startingAt": "a partire da {0}"
  },
  "priceRange": {
    "applyPriceRange": "Applica fascia di prezzo",
    "fromPriceRange": "Da {0} {1}",
    "fromToPriceRange": "{0} {2} - {1} {2}",
    "invalidPriceRange": "Fascia di prezzo non valida",
    "priceRange": "Fascia di prezzo",
    "priceRangeFrom": "Fascia di prezzo",
    "priceRangeTo": "Raggio di prezzo",
    "toPriceRange": "Fino a {0} {1}"
  },
  "print": "Stampa",
  "privacy": "Privacy",
  "privacyConsent": "Accetto che i miei dati siano trattati in conformità con l'informativa sulla privacy.",
  "product": "Prodotto",
  "productAccessories": "Accessori",
  "productComparison": {
    "highlightDifferences": "Enfatizzare le differenze",
    "noData": "Non sono stati trovati dati comparabili per i prodotti selezionati",
    "noMobileVersion": "Il confronto tra i prodotti non è disponibile nella visualizzazione mobile",
    "noProducts": "Nessun prodotto a confronto",
    "pageTitle": "Confronta i prodotti",
    "removeProduct": "Rimuovere il prodotto dal confronto"
  },
  "productDescription": "Descrizione",
  "productId": "ID prodotto",
  "productIdentifiers": "ID prodotto",
  "productNoLongerAvailable": "Prodotto non più disponibile",
  "products": "Prodotti",
  "productSort": {
    "AVAILABILITY": "Disponibilità",
    "CALC_PRICE_ASC": "Prezzo ascendente",
    "CALC_PRICE_DESC": "Prezzo in discesa",
    "NAME_ASC": "Nome del prodotto ascendente",
    "NAME_DESC": "Nome del prodotto decrescente",
    "POPULARITY": "Popolarità",
    "RELEVANCE": "Rilevanza",
    "STOCK": "Livello delle scorte"
  },
  "productStockInfo": {
    "nextDelivery": "La prossima data di consegna secondo il distributore è prevista per il {0}.",
    "nextDeliveryB2B": "Data di consegna prevista al fornitore a monte: {0}.",
    "noNextDelivery": "La data di consegna precisa non è nota.",
    "onStock": "{0} in magazzino",
    "onSupply": "{0} presto disponibile",
    "unavailableMessage": "Questo prodotto non è disponibile."
  },
  "punchout": {
    "backToProcurement": "Torna al tuo sistema",
    "backToProcurementCaption": "Senza ordine nel sistema | Trasferire un articolo nel sistema | Trasferite {n} posizioni nel vostro sistema",
    "table": {
      "position": "ID",
      "price": "Prezzo",
      "quantity": "Quantità",
      "sum": "Somma",
      "title": "Titolo"
    }
  },
  "quantityFrom": "Quantità da",
  "quoteOutdated": {
    "description": "Non è stato possibile inviare l'offerta perché non è più aggiornata. Si prega di ricaricare l'offerta e di effettuare nuovamente l'ordine.",
    "title": "Offerta non più aggiornata"
  },
  "quotePreview": "Siete nell'anteprima dell'offerta",
  "quoteRegistration": {
    "description": "Registrandoti nel tuo Essential Shop personale riceverai...",
    "products": "Accesso a <b>50.000 prodotti IT</b>",
    "quoteDocument": "visualizzazione di tutti i <b>documenti d'offerta</b> rilevanti",
    "quoteHistory": "la <b>cronologia delle offerte</b> con tutte le offerte già ricevute",
    "quoteRequest": "l'opzione di inviare <b>richieste</b>"
  },
  "quoteRequest": {
    "cannotEditRequest": "Non è più possibile modificare, la richiesta è già stata inviata.",
    "emptyRequest": "Nessun prodotto aggiunto",
    "lineItemAdded": "L'articolo è stato aggiunto con successo",
    "notInAssortment": "Attualmente non presente nell'assortimento",
    "requestAgain": "Richiedere di nuovo",
    "requestNotFound": "La richiesta di preventivo non è stata trovata",
    "sendRequest": "Invia la richiesta",
    "sentQuoteRequest": "La richiesta di preventivo è stata inviata",
    "textLineItemAdd": "Aggiungi un'opzione a testo libero",
    "textLineItemChangeError": "Non è stato possibile modificare il titolo della posizione del testo"
  },
  "quotes": {
    "acceptQuote": "Accettare l'offerta",
    "addProductToExistingQuote": "Aggiungi il prodotto alla richiesta esistente:",
    "addProductToNewQuote": "o creare una nuova richiesta:",
    "author": "Autore",
    "createRequest": "Creare una richiesta",
    "declineInformation": "Il preventivo è stato rifiutato da {0} il {1}.",
    "declineQuote": "Rifiutare l'offerta",
    "declineQuoteDialog": "È sicuro di voler rifiutare questa l'offerta?",
    "deleteDescription": "È sicuro di voler eliminare questa richiesta?",
    "deleteTitle": "Cancella la richiesta",
    "deselectOptionalItem": "Deselezionare la posizione opzionale",
    "duplicateUserWarning": "Non è possibile accettare questa offerta perché il vostro indirizzo e-mail è già stato associato a un'altra azienda. Si prega di contattare il creatore dell'offerta.",
    "editTitle": "Modifica il titolo della richiesta",
    "new": "Nuovo",
    "noLongerValid": "Questa, offerta è scaduta il \"{0}\" e non è più valida.",
    "noOptionalPosition": "Nessuna posizione opzionale",
    "noQuoteEmptySpace": "Non è ancora disponibile un'offerta",
    "noQuoteRequestsFound": "Nessuna richiesta disponibile",
    "noQuotesFound": "Nessuna offerta disponibile",
    "quote": "Offerta",
    "quoteRequested": "La richiesta è stata creata con successo",
    "quotes": "Offerte",
    "request": "Richiesta",
    "selectOptionalItem": "Select optional position",
    "showActivity": "Attività espositive"
  },
  "quoteStatus": {
    "ACCEPTED": "Accettato",
    "DRAFT": "Bozza",
    "NEGOTIATION": "In corso",
    "REJECTED": "Rifiutato",
    "REQUESTED": "Richiesto"
  },
  "readOnlyMode": "Si è attualmente in modalità di sola lettura.",
  "realtimePrices": "Prezzi in tempo reale",
  "realtimePricesLoaded": "Prezzi in tempo reale caricati",
  "recipients": "Destinatari",
  "refresh": "Ricarica",
  "refreshPage": "Ricarica la pagina",
  "register": "Registro",
  "registerCompany": "Registrazione dell'azienda",
  "registration": "Registrazione",
  "registrationDisabled": "Registrazione disattivata",
  "registrationDisabledDescription": "Il gestore ha disattivato la registrazione e l'accesso a questo portale.",
  "registrationLinkSent": "Un'e-mail con il link per la registrazione è stata inviata al vostro indirizzo e-mail. Aprire il link per completare la registrazione.",
  "registrationRequested": "La richiesta è stata trasmessa al gestore del portale. Riceverete una notifica quando la richiesta sarà stata accettata.",
  "removeDialog": "È sicuro di voler rimuovere questo dipendente?",
  "removeProductFromCart": "Rimuovere il prodotto dal carrello",
  "removeProductFromCollection": "Rimuovere il prodotto dalla raccolta",
  "removeProductFromQuoteRequest": "Rimuovere il prodotto dalla richiesta",
  "requestPrice": "Richiesta prezzo",
  "requestRegistration": "Richiesta di accesso",
  "resetPassword": "Reimpostare la password",
  "rma": {
    "requested": "Richiesta di restituzione inviata",
    "return": "Spedizione di ritorno",
    "returned": "restituito",
    "returnReason": "Motivo della restituzione",
    "selectedPositions": "Posizioni selezionate",
    "selectPositions": "Selezionare gli articoli per la spedizione di ritorno",
    "selectProductForReturn": "Selezionare il prodotto da restituire",
    "selectReturnReason": "Selezionare il motivo"
  },
  "save": "Salva",
  "saveAddress": "Salva indirizzo",
  "search": "Ricerca",
  "searchAll": "Cerca tutti",
  "searchResults": "Cerca \"{0}\" nei prodotti",
  "send": "Inviare",
  "sendInvitation": "Inviare l'invito",
  "serialNumbers": {
    "copyAll": "Copiare tutti",
    "serialNumbers": "Numeri di serie",
    "serialNumbersCopied": "Numeri di serie copiati negli appunti"
  },
  "serverOffline": {
    "description": "Il portale non è attualmente disponibile per manutenzione. Si prega di riprovare più tardi.",
    "title": "Portale non disponibile"
  },
  "shippingCostsShort": "Spedizione",
  "shoppingCart": "Carrello della spesa",
  "shortUrl": {
    "enterZipCode": "Per aprire l'offerta, inserire il codice postale del proprio indirizzo:",
    "enterZipCodeTitle": "Inserire il codice postale",
    "error": "Oops! Questo link non è valido!",
    "wrongZipCode": "Il codice postale inserito non è valido!"
  },
  "showCategories": "Mostra categorie",
  "showErrorOrders": "Mostra tutti gli ordini con stato di errore",
  "showPassword": "Mostra la password",
  "signIn": "Accesso",
  "signOut": "Esci",
  "sortBy": "Ordina per",
  "sortbyAsc": "Ordina in ordine crescente per “{0}”.",
  "sortByDesc": "Ordina in ordine decrescente per “{0}”.",
  "sources": "Fonti di approvvigionamento",
  "status": "Stato",
  "stock": "Stock",
  "stockStatus": {
    "Available": "Disponibile",
    "NotAvailable": "Non disponibile",
    "OnOrder": "Su ordinazione",
    "OnStock": "In magazzino",
    "Ordered": "Presto disponibile",
    "Unknown": "Sconosciuto",
    "Warehouse": "stock esterno"
  },
  "stockStatusDescription": "Lo stato delle scorte è “{0}”.",
  "subsidiaryMode": "Vista del cliente - L'utente ha effettuato l'accesso a {0}",
  "success": {
    "addedToCollection": "Prodotto aggiunto con successo alla collezione",
    "addedToCollectionLink": "Prodotto aggiunto con successo alla collezione \"{0}\" >>",
    "addedToComparison": "Prodotto aggiunto per confronto",
    "addedToQuote": "Il prodotto è stato aggiunto con successo alla richiesta",
    "addedToQuoteLink": "Il prodotto è stato aggiunto con successo alla richiesta di informazioni \"{0}\". >>",
    "addressCreated": "L'indirizzo è stato creato",
    "addressDeleted": "L'indirizzo è stato cancellato",
    "addressSaved": "L'indirizzo è stato salvato",
    "cartRefreshed": "Carrello aggiornato",
    "changeLanguage": "Lingua modificata",
    "changePassword": "La password è stata modificata con successo",
    "essentialShopActivationRequested": "Richiesta di attivazione inviata",
    "invitationSent": "Invito inviato con successo",
    "orderArchived": "Ordine archiviato",
    "orderDearchived": "Ordine caro",
    "productAdded": "Il prodotto è stato aggiunto al carrello",
    "productDeleted": "Il prodotto è stato eliminato dal carrello",
    "productRequested": "Richiesta di prodotto inviata",
    "quoteArchived": "Offerta archiviata",
    "quoteDearchived": "Offerta dearchiviata",
    "registrationComplete": "La registrazione è andata a buon fine",
    "removedFromComparison": "Il prodotto è stato rimosso dal confronto",
    "resetPassword": "È stata inviata un'e-mail a \"{0}\" se esiste un account utente attivo."
  },
  "supplier": "Fornitore",
  "supplierPid": " Distributore n.",
  "switchSubsidiary": "Cambia azienda",
  "switchSubsidiaryHint": "È possibile accedere ad altre aziende",
  "technicalData": "Dati tecnici",
  "terms": "GTC",
  "time": {
    "day": "giorno",
    "hour": "ora",
    "minute": "minuto",
    "month": "mese",
    "year": "anno"
  },
  "title": "Titolo",
  "to": "a",
  "today": "Oggi",
  "topiExpiredHint": "L'offerta di topi è purtroppo scaduta. La preghiamo di aggiungere nuovamente i prodotti al suo carrello utilizzando il menu a tre punti e di cliccare su “Continue to rental configuration”.",
  "transactionType": {
    "DELIVERY": "Bolla di consegna",
    "INVOICE": "Fattura proforma",
    "ORDER": "Ordine",
    "ORDERSTATUS": "Risposta all'ordine",
    "PAYMENT": "Pagamento"
  },
  "unknown": "sconosciuto",
  "updated": "Aggiornato",
  "user": {
    "avatar": "Avatar",
    "company": "Azienda",
    "contactTitle": "Titolo del contatto",
    "department": "Dipartimento",
    "email": "E-mail",
    "firstName": "Nome",
    "language": "Lingua",
    "lastName": "Cognome",
    "permissions": {
      "changeSubsidiary": "Cambio di società",
      "changeSubsidiaryDescription": "Determina se l'utente è autorizzato ad accedere alle aziende collegate.",
      "permissions": "Autorizzazioni per gli utenti",
      "shopAdmin": "Admin",
      "shopAdminDescription": "In qualità di amministratore, l'utente è autorizzato a modificare i diritti, i dettagli di contatto, i limiti degli ordini e le approvazioni di altri dipendenti. Inoltre, l'utente amministratore può invitare nuovi colleghi direttamente nel portale.",
      "submitOrder": "Effettuare gli ordini",
      "submitOrderDescription": "Determinare se l'utente è autorizzato a effettuare ordini."
    },
    "phone": "Numero di telefono",
    "phoneMobile": "Numero di cellulare",
    "settings": {
      "allowTracking": "Migliorare l'esperienza utente",
      "allowTrackingDescription": "Partecipa al programma di ottimizzazione per una migliore esperienza utente.",
      "settings": "Impostazioni utente"
    }
  },
  "validDate": "Valido fino a",
  "viewToggle": {
    "ordersApprovals": "Passa la panoramica dell'ordine su \"Ordini approvabili\"",
    "ordersGrid": "Passa la panoramica dell'ordine alla vista colonna",
    "ordersList": "Passa la panoramica dell'ordine alla visualizzazione elenco",
    "productsCards": "Passa la panoramica del prodotto alla vista piastrellata",
    "productsList": "Passa la panoramica del prodotto alla visualizzazione elenco",
    "quoteActivityChat": "Switch Activity View to Chat",
    "quoteActivityHistory": "Cambia le attività visualizzate alla cronologia"
  },
  "windowTitle": {
    "Collection": "Collezione",
    "CompanyOrderLimit": "Approvazione dell'ordine",
    "Login": "Pagina di accesso",
    "Registration": "Pagina di registrazione",
    "StartPage": "Pagina iniziale"
  },
  "writeSomething": "Scrivi qualcosa...",
  "yes": "Sì",
  "yesterday": "Ieri"
}
